import React from "react";
import senderImg from "../../components/images/png/sender_img.png";
const UserListView = ({ selectedProfile, handleProfileClick }) => {
    const SidebarProfileList = [
        {
          image: senderImg,
          name: "James",
          description: "Lectus nunc egestas faucibus",
          groupchat: [
            {
              messages: "Hi",
            },
          ],
        },
        {
          image: senderImg,
          name: "James",
          description: "Lectus nunc egestas faucibus",
          groupchat: [
            {
              messages: "How are you",
            },
          ],
        },
        {
          image: senderImg,
          name: "James",
          description: "Lectus nunc egestas faucibus",
          groupchat: [
            {
              messages: "Hi",
            },
          ],
        },
        {
          image: senderImg,
          name: "James",
          description: "Lectus nunc egestas faucibus",
          groupchat: [
            {
              messages: "How are you",
            },
          ],
        },
        {
          image: senderImg,
          name: "James",
          description: "Lectus nunc egestas faucibus",
          groupchat: [
            {
              messages: "Hi",
            },
          ],
        },
        {
            image: senderImg,
            name: "Jim",
            description: "Lectus nunc egestas faucibus",
            groupchat: [
              {
                messages: "Hi",
              },
            ],
          },
      ];
  return (
    <>
      <div id="sidebar">
        {SidebarProfileList.map((obj, index) => {
          return (
            <div
              className={`profile_box ${
                index === selectedProfile ? "bg-offgray" : ""
              }`}
              key={index}
              onClick={() => handleProfileClick(index)}
            >
              <div
                className={`d-flex flex-column align-items-center flex-md-row gap-lg-3 gap-2 border_bottom ${
                  index === selectedProfile - 1
                    ? "bottom_border_transparent"
                    : ""
                }`}
              >
                <span>
                  <img
                    src={obj.image}
                    alt="profile"
                    width={44}
                    height={44}
                    className="w-full rounded-pill"
                  />
                </span>
                <div>
                  <h3 className="font-sm text-black mb-0">{obj.name}</h3>
                  <p className="text-gray mb-0 font-sm d-none d-md-block">
                    {obj.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default UserListView;